import { render, staticRenderFns } from "./masterCard.vue?vue&type=template&id=a5fe6388&scoped=true"
import script from "./masterCard.vue?vue&type=script&lang=js"
export * from "./masterCard.vue?vue&type=script&lang=js"
import style0 from "./masterCard.vue?vue&type=style&index=0&id=a5fe6388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe6388",
  null
  
)

export default component.exports